export default __webpack_public_path__ + "static/media/credit.4b5572a2.svg";